import React, {useState} from 'react';
import {useGallery} from 'store/gallery'
import {Collections, List, Search, Add} from './';
import * as Icons from "react-feather";

export default function Gallery(props) {
   const [addFile, setAddFile] = useState(false);
   const [selectedItem, setSelectedItem] = useState(null);
   const {submittDeleteFile, dispatch, getList, getCollections, showGallery, handleSelectFile, toggleGallery} = useGallery();

   if (!showGallery) {
      return null
   }

   const handleDeleteFile = (item) => {
      dispatch(submittDeleteFile(item.id, () => {
         dispatch(getList());
         dispatch(getCollections());
         setSelectedItem(null);
      }));
   }

   return (
      <>
         <div className="fixed z-50 inset-0 overflow-y-auto" style={{zIndex: 99999}} aria-labelledby="modal-title"
              role="dialog" aria-modal="true">
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

               <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    aria-hidden="true"></div>
               <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                            &#8203;
                    </span>
               <div
                  className="inline-block align-bottom bg-white rounded-lg text-right overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl sm:w-full">
                  <div className="box px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                     <div id="gallery-head" className="flex sm:items-center justify-between py-3 rounded-lg">
                        <h6 className="text-lg font-bold">گالری</h6>
                        <div className="flex justify-center items-center w-2/4">
                           <button type="button" onClick={() => setAddFile(true)}
                                   className="w-full inline-flex justify-center rounded border border-violet-300 shadow-sm py-1 px-2 text-base font-medium transition duration-500 ease-in-out  transform hover:translate-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-600 sm:mt-0 sm:mx-1 sm:w-auto sm:text-sm btn btn-primary">
                              <span>افزودن رسانه</span>
                              <Icons.Paperclip className="p-1"/>
                           </button>
                           {selectedItem &&
                           <button type="button" onClick={() => handleSelectFile(selectedItem)}
                                   className="w-full inline-flex justify-center rounded border border-gray-300 shadow-sm py-1 px-2 btn btn-success text-base font-medium  hover:bg-gray-50 focus:outline-none transform hover:translate-1 focus:ring-2 focus:ring-offset-2 focus:ring-violet-600 sm:mt-0 sm:mx-1 sm:w-auto sm:text-sm">
                              <span>انتخاب رسانه</span>
                              <Icons.MousePointer className="p-1"/>
                           </button>
                           }
                           {selectedItem &&
                           <button type="button" onClick={() => handleDeleteFile(selectedItem)}
                                   className="w-full inline-flex justify-center rounded border border-gray-300 shadow-sm py-1 px-2 btn btn-danger text-base font-medium  hover:bg-gray-50 focus:outline-none  focus:ring-2 focus:ring-offset-2 focus:ring-violet-600 sm:mt-0 sm:mx-1 sm:w-auto sm:text-sm">
                              <span>حذف رسانه</span>
                              <Icons.Trash2 className="p-1"/>
                           </button>
                           }
                        </div>
                        <Search/>
                        <button type="button" onClick={() => dispatch(toggleGallery())}
                                className="transition duration-500 ease-in-out  transform hover:-translate-1 bg-bg-transparent hover:text-rose-500  border-none px-2 mx-3 rounded-full ">
                           <Icons.X/>
                        </button>
                     </div>
                     <hr className="my-4"/>
                     <div id="gallery-main" className="flex w-full" style={{minHeight: "75vh"}}>
                        {addFile ? (<Add handleBack={() => {
                           setAddFile(false)
                        }}/>) : (<>
                           <Collections/>
                           <List select={(item) => {
                              setSelectedItem(item)
                           }} selectedItem={selectedItem}/></>)}
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
}
